import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import AppVersionService from "../../pages/dashboard/Locality/Service/appVersionService";

const POLL_MS = 60 * 1000;
const DEFAULT_TITLE = "Update available";
const DEFAULT_MESSAGE =
  "New changes have occurred. Kindly refresh the web page.";

/** Version the user loaded with (in-memory; resets on full page reload). */
let loadedWebVersion = null;

const unwrapConfig = (res) => {
  if (!res) return null;
  const inner = res.data != null && typeof res.data === "object" ? res.data : res;
  if (inner && (inner.web !== undefined || inner._id)) return inner;
  return null;
};

export default function WebVersionNotifier() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(DEFAULT_TITLE);
  const [message, setMessage] = useState(DEFAULT_MESSAGE);

  const checkVersion = useCallback(async () => {
    try {
      const res = await AppVersionService.get();
      const config = unwrapConfig(res);
      if (!config) return;

      const serverWeb = String(config.web || "").trim();
      if (!serverWeb) return;

      if (loadedWebVersion == null) {
        loadedWebVersion = serverWeb;
        return;
      }

      if (serverWeb !== loadedWebVersion) {
        setTitle(String(config.updateTitle || config.title || "").trim() || DEFAULT_TITLE);
        setMessage(
          String(config.updateMessage || config.message || "").trim() || DEFAULT_MESSAGE
        );
        setOpen(true);
      }
    } catch {
      // Config may not exist yet; ignore until it is created.
    }
  }, []);

  useEffect(() => {
    checkVersion();
    const intervalId = window.setInterval(checkVersion, POLL_MS);
    const onFocus = () => checkVersion();
    window.addEventListener("focus", onFocus);
    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", onFocus);
    };
  }, [checkVersion]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: "8px 4px 4px",
          textAlign: "center",
        },
      }}
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" py={2} px={1}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              backgroundColor: "#e8f0fe",
              marginBottom: 20,
            }}
          >
            <SystemUpdateAltIcon style={{ fontSize: 40, color: "#1769d6" }} />
          </Box>
          <Typography variant="h5" style={{ fontWeight: 700, color: "#0f2d4d", marginBottom: 12 }}>
            {title}
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ lineHeight: 1.6, maxWidth: 420 }}>
            {message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center", padding: "8px 24px 24px" }}>
        <Button
          color="primary"
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
          style={{
            backgroundColor: "#1769d6",
            minWidth: 140,
            borderRadius: 8,
            padding: "8px 24px",
          }}
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
}
